import { bgColors, TextStyled, useResponsiveBooleansContext } from 'backgammon_ui_shared';
import React from 'react';
import { BetaRibbon, MenuItemButton, MenuItemIcon } from './SideMenuItem.styles';

interface Props {
  dataLabel?: string;
  iconPath: string;
  onClick?(): void;
  disabled?: boolean;
  isBeta?: boolean;
}

function SideMenuItem({ iconPath, onClick, children, disabled, dataLabel, isBeta }: React.PropsWithChildren<Props>) {
  const { isTabOrScreen } = useResponsiveBooleansContext();
  return (
    <MenuItemButton disabled={disabled} onClick={onClick} data-cy={dataLabel}>
      <MenuItemIcon isTabOrScreen={isTabOrScreen} iconPath={iconPath} />
      <TextStyled
        fontSize={isTabOrScreen ? 'extraLarge' : 'default'}
        style={{ color: bgColors.slate200 }}
        isStretched={false}
        marginLeft="20px"
      >
        {children}
      </TextStyled>
      {isBeta ? <BetaRibbon>BETA</BetaRibbon> : null}
    </MenuItemButton>
  );
}

export default SideMenuItem;
